package com.eladfinish.bible.contest.ui.common

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.unit.LayoutDirection

@Composable
fun RtlContainer(
    content: @Composable () -> Unit,
) {
    val layoutDirection = LayoutDirection.Rtl
    CompositionLocalProvider(
        value = LocalLayoutDirection provides layoutDirection,
        content = content,
    )
}
